import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from "../../core/utils/element-exists"

const InstagramSwiper = function () {
    // Instagram Cards Section
    const swiperRecipeIG = document.querySelectorAll( '.recipe-instagram' );
    if ( Object.keys(swiperRecipeIG).length ) {
        swiperRecipeIG.forEach( function( el ){
            const container = el;
            const swiperContainer = el.querySelector( '.swiper');
            let btnNext = container.querySelector('.swiper-button-next');
            let btnPrev = container.querySelector('.swiper-button-prev');

            const swiper = new Swiper( swiperContainer , {
                direction: 'horizontal',
                slidesPerView: "auto",
                spaceBetween: 15,
                navigation: {
                    nextEl: btnNext,
                    prevEl: btnPrev
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    1192: {
                        slidesPerView: 3,
                        spaceBetween: 120
                    }
                }
            })
        });
    }


}
  

export default InstagramSwiper;